import { Component, OnInit } from '@angular/core';
import { RegulationService } from 'src/app/core/services/regulation';

@Component({
  selector: 'app-rig-settings',
  templateUrl: './rig-settings.component.html',
  styleUrls: ['./rig-settings.component.scss']
})
export class RigSettingsComponent implements OnInit{
  sliderValue: number = 0.5;
  constructor(private regulationService: RegulationService){

  }

  ngOnInit(): void {
    this.regulationService.GetSimilarityThreshhold().subscribe((data:any) => {
      this.sliderValue = data.polices;
    })
  }

  updatePolicyThreshold(){
    this.regulationService.saveThreshholdData(this.sliderValue).subscribe((data: any) => {
      
    });
  }
}
